export default {
  name: 'plotSuspect',
  options: {
    menuIndex: 2,
    isHidden: true,
  },
};
